import APIError from '../APIError';

class PropertyManagement extends APIError {
  constructor(code, details = null) {
    super(code, 'PropertyManagement', details);
  }
}

export default PropertyManagement;
